module.exports = __webpack_public_path__ + "img/icon_favs.d4afda4.svg";